<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<ng-container *ngIf="!loading">
  <div class="mh">
    <div>
      <h2>工单详情</h2>
      <p>
        {{ info.ticket?.ticket_no }} · {{ info.ticket.platform?.name }} ·
        {{ info.ticket.bus_seat.bus.bus_account?.username }}
      </p>
    </div>
    <button class="close" mat-dialog-close>×</button>
  </div>
  <div class="mb" mat-dialog-content>
    <div class="ticket-summary">
      <h3>提交内容</h3>
      <div class="summary-row">
        <span>问题</span><b>{{ info.ticket.problem_item.name }}</b>
      </div>
      <div class="summary-row">
        <span>说明</span><b>{{ info.ticket.description }}</b>
      </div>
      <div class="summary-row">
        <span>截图</span>
        <app-image
          [fileid]="info.ticket.screenshot_url"
          width="100px"
          height="100px"
          (click)="preview(info.ticket.screenshot_url)"
        >
        </app-image>
      </div>
    </div>
    <div class="process-record">
      <h3>处理记录</h3>
      <div class="record-list">
        <div
          class="record-item"
          *ngFor="let item of info.timelines; let i = index"
          [ngClass]="{ old: i !== 0 }"
        >
          <i></i>
          <div>
            <b>{{ status(item.status) }}</b>
            <span>{{ item.content }}</span>
            <small>
              <app-datetime [text]="item.created_time"></app-datetime>
            </small>
          </div>
        </div>
      </div>
    </div>
    <div
      class="confirm-actions"
      *ngIf="info.ticket.status === 'waiting_confirmation'"
    >
      <button class="btn outline" (click)="unconfirm()" [disabled]="loadingBtn">
        未解决，重新提单
      </button>
      <button class="btn primary" (click)="confirm()" [disabled]="loadingBtn">
        确认已解决
      </button>
    </div>
  </div>
</ng-container>
